var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.element,{tag:"component",staticClass:"base-table-cell"},[_c('div',{staticClass:"base-table-cell__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }